import { useTeamContext } from 'contexts/group-practice-context/TeamContext';
import { useState } from 'react';
import MembersTable from './member-table/MembersTable';
import MemberNav from './memberNav/MemberNav';
// import MemberDetails from './memberDetails/MemberDetails';
import Toaster from '../utils/Toaster';
import AddNewMember from './addNewMember/addNewMember';
import Permissions from './permissions/Permissions';
import AddRoles from './roles/addRoles';

const GroupMember = () => {
  const [showAddMemberModal, setShowAddMemberModal] = useState(false);
  const [searchParam, setSearchParam] = useState('');
  const [currentPage, setCurrentPage] = useState('members');
  const { teamMembers, loading, error, setError, setLoading } = useTeamContext();
  const [success, setSuccess] = useState<any>();
  const [showAddRolesModal, setShowAddRolesModal] = useState(false);

  return (
    <div className='pl-3 gap-3 d-flex flex-column pt-3 h-100'>
      <Toaster
        successMsg={success?.toString()}
        errorMsg={error?.toString()}
        onClearSuccess={() => setSuccess(undefined)}
        onClearError={() => setError(undefined)}
      />
      {currentPage === 'members' ? (
        <>
          {showAddMemberModal && (
            <AddNewMember
              showAddMemberModal={showAddMemberModal}
              handleClose={() => {
                setShowAddMemberModal(false);
              }}
              setSuccessMsg={setSuccess}
              setError={setError}
              error={error}
            />
          )}
          {showAddRolesModal && (
            <AddRoles
              show={showAddRolesModal}
              onClose={() => setShowAddRolesModal(false)}
              setSuccessMsg={setSuccess}
              setError={setError}
            />
          )}
          <MemberNav
            memberCount={teamMembers?.length || 0}
            practiceSchedulerCount={
              teamMembers?.filter(
                member => member.role === 'PRACTICE_SCHEDULER',
              ).length || 0
            }
            searchParam={searchParam}
            setSearchParam={setSearchParam}
            setShowAddMemberModal={setShowAddMemberModal}
            setShowAddRolesModal={setShowAddRolesModal}
          />
          <MembersTable
            teamMembers={teamMembers}
            setCurrentPage={setCurrentPage}
            loading={loading}
            setError={setError}
            setLoading={setLoading}
            setSuccessMsg={setSuccess}
          />
        </>
      ) : (
        // <MemberDetails setCurrentPage={setCurrentPage} />
        <Permissions setCurrentPage={setCurrentPage} />
      )}
    </div>
  );
};

export default GroupMember;
